import React from 'react';
import { getChatComposerModeShortcutLabel } from './chatComposerHotkeys.js';
import {
  MODE_KEYS,
  normalizeQuickModeKey,
  resolveQuickModeIcon,
  resolveQuickModeStateText,
} from './composerShared.jsx';
import preserveInputFocus from './preserveInputFocus.js';
import './composer-mode-control.css';

export default function ComposerModeStrip({
  disabled = false,
  quickModeEntries = [],
  modeValue,
  modeButtonAnimatingKey,
  modeStatusByKey = {},
  onModeChange,
  setModeButtonAnimatingKey,
  modeButtonAnimationTimerRef,
}) {
  const modeEntries = (Array.isArray(quickModeEntries) ? quickModeEntries : [])
    .filter((entry) => entry.kind === 'mode');
  if (modeEntries.length === 0) {
    return null;
  }

  return (
    <div className="flare-composer-mode-strip">
      {modeEntries.map((entry) => {
        const normalizedModeValue = normalizeQuickModeKey(modeValue);
        const normalizedEntryKey = normalizeQuickModeKey(entry.key);
        const isActive = normalizedModeValue === normalizedEntryKey;
        const isAnimating = modeButtonAnimatingKey === entry.key;
        const shortcutLabel = getChatComposerModeShortcutLabel(entry.key, modeEntries);
        const buttonDisabled = disabled || typeof onModeChange !== 'function';
        const stateText = resolveQuickModeStateText(modeStatusByKey, normalizedEntryKey, isActive);
        return (
          <button
            key={entry.key}
            className={`flare-composer-quick-mode-toggle${isActive ? ' is-active' : ''}${isAnimating ? ' is-animating' : ''}`}
            disabled={buttonDisabled}
            aria-pressed={isActive}
            onMouseDown={preserveInputFocus}
            type="button"
            title={shortcutLabel ? `${entry.label} (${shortcutLabel})` : entry.label}
            onClick={() => {
              if (buttonDisabled) {
                return;
              }
              if (modeButtonAnimationTimerRef.current) {
                clearTimeout(modeButtonAnimationTimerRef.current);
              }
              setModeButtonAnimatingKey(entry.key);
              modeButtonAnimationTimerRef.current = setTimeout(() => {
                setModeButtonAnimatingKey('');
              }, 220);
              onModeChange?.(isActive ? MODE_KEYS.auto : entry.key);
            }}
          >
            <span className="flare-composer-quick-mode-icon">{resolveQuickModeIcon(entry.key)}</span>
            <span className="flare-composer-quick-mode-label">{entry.label}</span>
            {stateText ? <span className="flare-composer-quick-mode-state">{stateText}</span> : null}
          </button>
        );
      })}
    </div>
  );
}
